import Vue from 'vue';

Vue.component( 'input-archivo', () => import( '@com/inputs/input-archivo.vue' ) );
Vue.component( 'input-empresa', () => import( '@com/inputs/input-empresa.vue' ) );
Vue.component( 'input-archivo-multiple', () => import( '@com/inputs/input-archivo-multiple.vue' ) );
Vue.component( 'input-mes-dialog', () => import( '@com/inputs/input-mes-dialog.vue' ) );
Vue.component( 'input-condicion-iva', () => import( '@com/inputs/input-condicion-iva.vue' ) );
Vue.component( 'input-cuit', () => import( '@com/inputs/input-cuit.vue' ) );
Vue.component( 'input-fecha', () => import( '@com/inputs/input-fecha.vue' ) );
Vue.component( 'input-documento', () => import( '@com/inputs/input-documento.vue' ) );
Vue.component( 'input-email', () => import( '@com/inputs/input-email.vue' ) );
Vue.component( 'input-personas', () => import( '@com/inputs/input-personas.vue' ) );
Vue.component( 'input-tipo-envio', () => import( '@com/inputs/input-tipo-envio.vue' ) );
Vue.component( 'input-tipo-pago', () => import( '@com/inputs/input-tipo-pago.vue' ) );
Vue.component( 'input-banco', () => import( '@com/inputs/input-banco.vue' ) );
Vue.component( 'input-tipo-pedido', () => import( '@com/inputs/input-tipo-pedido.vue' ) );
Vue.component( 'porcentaje-grande', () => import( '@com/inputs/porcentaje-grande.vue' ) );
Vue.component( 'porcentaje-mediano', () => import( '@com/inputs/porcentaje-mediano.vue' ) );